import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import Message from '../../../component/Message'
import langM from './lang'
import { history } from 'src/core/router'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import localstorage from 'src/helper/localstorage'
import vs from '../../../helper/vconsole'
import config from 'src/core/config'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: langM.en,
    hostsystemDisplayId:'',
    rcList:[],
    language:'en'
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query

    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
     
    })
    let url = window.location.href
    let arr = url.split('?')[1].split('&')
    let text = arr[1]&& arr[1].split('=')[0] 
    let seachValue = arr[1]&& arr[1].split('=')[1] 
    
    if (language == 'en') {
      setDocumentTitle("Join Application")
    }else if (language == 'ar') {
      setDocumentTitle("انضم إلى التطبيق")
    }else if (language == 'tr') {
      setDocumentTitle("Uygulamaya Katıl")
    }
    // end
    let uid = await setUidToken(this.props.location.query)
    
    try {
      this.getHostsystem()
    } catch (error) {
      console.log(error)
    }
    this.setState({uid})
    if (text=='myText' && seachValue) {
     
      this.setState({
        hostsystemDisplayId:seachValue
      })
     await  this.findUser(seachValue)
    }
    console.log(url,this.props.location.query,text,seachValue,uid)
    this.getList()
  }

  setValue = async(e)=>{
    await this.setState({hostsystemDisplayId:e.target.value})
  }

  getHostsystem = async () => {
    let res = await http.post('/web/hostsystem/info')
    //判断状态
     if (res.code == 0 && res.res != null ) {
      history.replace(`app/tradeUnion?language=${this.state.language}`)
    }
  }

  findUser = async(sersd)=>{
    let { hostsystemDisplayId, uid } = this.state
    let hdid = hostsystemDisplayId.trim() || sersd.trim()
    let res = await http.post('/web/hostsystem/search', { "hostsystemDisplayId":hdid })
    if (!hostsystemDisplayId) return
    if (res.code ==0) {
      if (res.res) {
        this.setState({ueriInfo:res.res,hostsystemDisplayId:hdid})
      }else{
        this.refs.msg.show(this.state.lang.notExist)
      }
    }else {
      if (uid == 1008152) {
       return this.refs.msg.show(res.msg)
      }
      this.refs.msg.show(res.msg,',',hdid)
    }
  }
  addHost = async()=>{
     let { ueriInfo:{ hostSystemId }, uid} = this.state   
     
     if ( !hostSystemId) return
     let res = await http.post('/web/hostsystem/apply', { hostSystemId,uid:uid })
     if (res.code == 0 ) {
      this.refs.msg.show(this.state.lang.successful)
     }else if (res.code == 89){
      this.refs.msg.show(this.state.lang.hadApplyText)
     }else if (res.code == 90){
      this.refs.msg.show(this.state.lang.haveHost)
     }
     this.setState({
      hostsystemDisplayId:'',
      ueriInfo:{}
     })
  }

 getList = async()=>{
  let res = await http.post('/web/hostsystem/myapplylist', {})
   console.log(res)
   if (res.code ==0 && res.res) {
     this.setState({rcList:[...res.res,...res.res]})
   }
 }

  render() {
    let { lang , ueriInfo, hostsystemDisplayId, historyList , rcList, language, } = this.state
    return (
      <div className="invite-new-host">
        <div className="find-user">
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e=>this.setValue(e)} placeholder={lang.enterID}  defaultValue={hostsystemDisplayId}></input>
            <div className="find-line"></div>
            <div className={`find-btn ${hostsystemDisplayId.length>0?'havevalue':''}`} onClick={this.findUser}>{lang.find}</div>
          </div>
          {ueriInfo && <div className="application-user-info">
            {/* <div className="avatar-root">
              <img className="avatar-img" src={ueriInfo.avatarurl}></img>
              {ueriInfo.gender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
              {ueriInfo.gender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
            </div> */}
            <div className="user-infos">
              <div className="user-info-top">
                <div className="top-text">{language=='ar'?'اسم الوكالة ':language=='tr'?'Ajans İsmi':'Agency Name'}:{ueriInfo.hostSystemName}</div>
              </div>
              <div className="user-info-buttom">{language=='ar'?'معرف الوكاله':language=='tr'?'Ajans ID':'Agency ID'}:{ueriInfo.hostSystemDisplayId}</div>
            </div>
          </div>}
          <div className={`invite ${ueriInfo?'':'on-userinfo'}`} onClick={this.addHost}>{lang.apply}</div>

          
        </div>
        <div className='list-item-sadwbkbkwqe'>
          {rcList.length>0 && rcList.map((item,index)=>(<div className='item-in-item' key={index}>
              <div className='join-text'>Apply Join in</div>
              <div className='guild-info'>{item.hostSystemName}({item.hostSystemDisplayId})</div>
              <div className='rc-time'>{item.timeInvited}</div>
             </div>))}

          </div>
        <Message ref="msg" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/find-hostJoin/index.js